import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTaskAttachments } from '../../store/slices/tasksReducer'
import { showCarrousel, setImages } from '../../store/slices/carrouselReducer'

const Photos = (props) => {
  const dispatch = useDispatch();
  const { task, attachments } = useSelector(state => state.tasks);
  const { images } = useSelector(state => state.carrousel);

  useEffect(() => {
    if(task.id) {
      dispatch(fetchTaskAttachments(task.id));
    }
  }, [dispatch, task.id]);


  useEffect(() => {
    dispatch(setImages(attachments.map(({ data })=> ({
      src: data.downloadUrl
    }))));
  }, [dispatch, attachments]);
  if (images.length === 0) return (<></>);
  return (<>
    <div className="photosholder">
      {images.map((img) => {
        return <div key={img.src} className="photoholder" onClick={() => dispatch(showCarrousel(img))}>
          <img src={img.src} alt={img.src} className="mainImage" />
        </div>
      })}
    </div>
  </>);
};

export default Photos;
